<template>
  <div class="app-container bj-label-colon">
    <el-form ref="form" :model="form" :rules="rules" label-width="300px">
      <BjDivider right-fixed
        >{{ $t('StockVerifyConfigutration.strategy') }}
        <template slot="right">
          <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
          <el-button v-permission:SettingStockAuditStrategy_Save @click="resetForm('form')"
            >{{ $t('resetText') }}</el-button
          >
          <el-button
            v-permission:SettingStockAuditStrategy_Save
            type="primary"
            @click="handleConfirm('form')"
            >{{ $t('saveText') }}</el-button
          >
        </template>
      </BjDivider>
      <el-form-item :label="$t('StockVerifyConfigutration.audit')" prop="allotAudit">
        <el-switch v-model="form.allotAudit" />
      </el-form-item>

      <el-form-item :label="$t('StockVerifyConfigutration.virtual')" prop="transferAudit">
        <el-switch v-model="form.transferAudit" />
      </el-form-item>

      <el-form-item :label="$t('StockVerifyConfigutration.approval')" prop="stockReservedAudit">
        <el-switch v-model="form.stockReservedAudit" />
      </el-form-item>

      <el-form-item :label="$t('StockVerifyConfigutration.review')" prop="branchWarehouseAudit">
        <el-switch v-model="form.branchWarehouseAudit" />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { stockApi } from '@/api';
const getDefaultForm = () => {
  return {
    id: null,
    tenantId: null,
    // 审核
    allotAudit: true,
    transferAudit: true,
    stockReservedAudit: true,
    branchWarehouseAudit: true,
    // 规则
    radixPointComputeMode: 'trunc',
    backordersPriorityStatus: true,
    backordersPriorityRule: true,
    backordersNumberRule: 1,
    backordersChannelPriority: '[]',
    channelPriority: '[]',
    virtualReplenishPriorityRule: 'interline-virtual,qty-virtual,ratio-virtual',
    sameVirtualReplenishPriorityRule: 0,
    virtualDateSort: true,
    virtualSpaceSort: true,
    stockDeductionPriorityRule: 'interline-virtual,qty-virtual,ratio-virtual',
    subVirtualReplenishPriorityRule: 0,
    subVirtualDateSort: true,
    inventoryOversoldRatio: 100,
  };
};
export default {
  name: 'SettingStockAuditStrategy',
  mixins: [viewMiXin],
  data() {
    return {
      form: getDefaultForm(),
      rules: {},
    };
  },
  watch: {},
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      stockApi.detailRules().then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.form = { ...this.form, ...res };
        }
      });
    },
    /* 关闭弹窗 */
    handleClose() {
      this.cancel();
    },
    resetForm() {
      this.$confirm(this.$t('StockVerifyConfigutration.confirmMsg'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.$refs.form.resetFields();
          this.refresh();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('StockVerifyConfigutration.cancelled'),
          });
        });
    },
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return this.$scrollToFormError();
        const API_DATA = this.$lodash.clone(this.form);
        this.updateApi(API_DATA);
      });
    },
    updateApi(API_DATA) {
      stockApi.updateRules(API_DATA).then(res => {
        this.refresh();
      });
    },
  },
};
</script>
